<!-- 自定义商城 -->
<template>
  <div class="page">
    <div :style="{ paddingBottom: buttonNavList.length ? '60px' : '' }">
      <div v-for="item in componentList" :key="item.id" class="component">
        <!-- 文字说明 -->
        <div class="text" v-if="item.type === 'text'">
          <p>{{ item.props.text }}</p>
        </div>
        <!-- 商品内容 -->
        <div class="content" v-if="item.type === 'content'">
          <div class="content_nav">
            <van-tabs v-model:active="active" @change="changeTab">
              <van-tab
                :title="item"
                v-for="(item, index) in indexList"
                :key="index"
              >
                <!-- 下拉刷新 + 上拉加载 -->
                <van-pull-refresh
                  v-model="refreshing"
                  @refresh="onRefresh"
                  :pulling-text="'下拉即可刷新...'"
                  :loosing-text="'释放即可刷新...'"
                  :loading-text="'加载中...'"
                >
                  <van-list
                    v-model:loading="loadingMore"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoadMore"
                    :immediate-check="false"
                  >
                    <!-- 列表式 -->
                    <template v-if="templateNo === '1'">
                      <div
                        class="goods_list"
                        v-for="items in goodsList"
                        :key="items.id"
                        @click="handleGoodsClick(items)"
                      >
                        <div class="goods_list_top">
                          <img :src="items.img" />
                          <div class="goods_list_top_r">
                            <div class="list_title">{{ items.title }}</div>
                            <div class="list_info">{{ items.info }}</div>
                            <div class="list_sales">销量 {{ items.showSalesVolume }}</div>
                            <div class="list_price">
                              <div class="price">
                                ￥<span class="price_num">{{
                                  items.price
                                }}</span>
                              </div>
                              <van-button class="btn">立即办理</van-button>
                            </div>
                          </div>
                        </div>
                        <div class="list_tagList">
                          <div
                            class="tag"
                            v-for="(tag, tagIndex) in items.tagList"
                            :key="tagIndex"
                            :style="{
                              backgroundColor: getTagColor(tagIndex).background,
                              color: getTagColor(tagIndex).color,
                            }"
                          >
                            {{ tag }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <!-- 卡片式 -->
                    <template v-if="templateNo === '2'">
                      <div class="goods_card">
                        <div
                          class="goods_card_item"
                          v-for="items in goodsList"
                          :key="items.id"
                          @click="handleGoodsClick(items)"
                        >
                          <div class="goods_card_item_img">
                            <img :src="items.img" />
                          </div>
                          <div class="card_title">{{ items.title }}</div>
                          <div class="card_info">{{ items.info }}</div>
                          <div class="card_tag">
                            <div
                              class="card_tag_item"
                              v-for="(tag, tagIndex) in items.tagList"
                              :key="tagIndex"
                              :style="{
                                backgroundColor:
                                  getTagColor(tagIndex).background,
                                color: getTagColor(tagIndex).color,
                              }"
                            >
                              {{ tag }}
                            </div>
                          </div>
                          <div class="card_price">
                            ￥<span class="price_num">{{ items.price }}</span>
                          </div>
                          <div class="card_sales">销量 {{ items.showSalesVolume }}</div>
                        </div>
                      </div>
                    </template>
                  </van-list>
                </van-pull-refresh>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <!-- 轮播图 -->
        <div v-else-if="item.type === 'carousel'">
          <template v-if="item.props.carouselList.length">
            <van-swipe
              class="carousel"
              :autoplay="3000"
              indicator-color="white"
            >
              <van-swipe-item
                v-for="(items, index) in item.props.carouselList"
                :key="index"
              >
                <img :src="items.url" @click="handleSwipe(items)" />
              </van-swipe-item>
            </van-swipe>
          </template>
        </div>
        <!-- 顶部导航 -->
        <div v-else-if="item.type === 'top-nav'">
          <div class="topnav">
            <div
              class="topnav_item"
              v-for="(items, index) in item.props.navList.filter(
                (nav) => nav.checked
              )"
              @click="handleTopNavClick(items)"
              :key="index"
            >
              <div class="flex">
                <img
                  :src="
                    items.icon === '/src/assets/zehao/kefu.png'
                      ? kefu
                      : items.icon === '/src/assets/zehao/order.png'
                      ? order
                      : items.icon === '/src/assets/zehao/feedback.png'
                      ? feedback
                      : items.icon
                  "
                />
              </div>
              <span>{{ items.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部导航固定位置 -->
    <div v-if="buttonNavList.length" class="fixed_bottom">
      <div class="bottom">
        <div
          class="bottom_item"
          v-for="(item, index) in buttonNavList[0].props.navList"
          @click="handleBottomNavClick(item)"
          :key="index"
        >
          <div class="flex">
            <img
              :src="
                item.icon === '/src/assets/zehao/home.png'
                  ? home
                  : item.icon === '/src/assets/zehao/kefu.png'
                  ? kefu
                  : item.icon === '/src/assets/zehao/order.png'
                  ? order
                  : item.icon === '/src/assets/zehao/feedback.png'
                  ? feedback
                  : item.icon
              "
            />
          </div>
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import home from "../../assets/home.png";
import kefu from "../../assets/kefu.png";
import order from "../../assets/order.png";
import feedback from "../../assets/feedback.png";
import { getGoodsList, getCustomMallConfig } from "@/api/api";
import router from "../../router";

export default {
  name: "customMall",
  data() {
    return {
      home: home,
      kefu: kefu,
      order: order,
      feedback: feedback,
      code: "",
      componentList: [], // 组件列表
      indexList: ["全部", "移动", "联通", "电信", "广电"], // 商品顶部索引
      active: 0,
      goodsList: [],
      // 分页参数
      pageParams: {
        current: 1,
        size: 10,
        total: 0,
        pages: 0, // 总页数
      },
      loading: false,
      refreshing: false, // 下拉刷新状态
      loadingMore: false, // 上拉加载状态
      finished: false, // 是否加载完成
      // Tags标签颜色配置方案
      tagColors: [
        { background: "#F7E6E6", color: "#D6242D" },
        { background: "#E1EAFA", color: "#2877F7" },
        { background: "#FAF0E6", color: "#FA962A" },
        { background: "#E1F5EC", color: "#249E65" },
        { background: "#FBEDFF", color: "#B361CA" },
      ],
      templateNo: "1",
    };
  },
  created() {
    console.log("params", this.$route.params);
    if (this.$route.params) {
      this.code = this.$route.params.code;
    }
    this.getConfig();
    this.getGoodsList();
  },
  computed: {
    buttonNavList() {
      return this.componentList.filter((item) => item.type === "bottom-nav");
    },
    // 根据当前tab获取上游渠道类型
    currentUpstreamChannelType() {
      // 0全网通，1中国移动，2中国联通，3中国电信，4中国广电
      const typeMap = {
        0: null, // 全部不传参数
        1: 1, // 移动
        2: 2, // 联通
        3: 3, // 电信
        4: 4, // 广电
      };
      return typeMap[this.active];
    },
  },
  methods: {
    // 获取标签颜色（按顺序循环分配）
    getTagColor(index) {
      return this.tagColors[index % this.tagColors.length];
    },
    // 点击轮播图事件
    handleSwipe(record) {
      console.log("点击轮播图事件", record);
      window.location.href = record.link;
    },
    // 处理顶部导航事件
    handleTopNavClick(record) {
      console.log("处理顶部导航事件", record);
      if (record.pageLink) {
        window.location.href = record.pageLink;
      } else {
        if (record.pageType === 0) {
          window.location.href = "https://im-c.zmyiot.com/?appid=bdad6316";
        } else if (record.pageType !== 0 && record.pageType !== 3) {
          const targetPath =
            record.pageType === 1
              ? "/order"
              : record.pageType === 2
              ? "/report"
              : "/";
          router.push({
            path: targetPath,
          });
        } else {
          this.$toast("菜单暂无配置");
        }
      }
    },
    // 处理底部导航事件
    handleBottomNavClick(record) {
      console.log("处理底部导航事件", record);
      if (record.pageLink) {
        window.location.href = record.pageLink;
      } else {
        if (record.pageType === 1) {
          window.location.href = "https://im-c.zmyiot.com/?appid=bdad6316";
        } else if (record.pageType !== 1 && record.pageType !== 4) {
          const targetPath =
            record.pageType === 0
              ? `/customMall/${this.code}`
              : record.pageType === 2
              ? "/order"
              : record.pageType === 3
              ? "/report"
              : "/";

          // 避免跳转到当前页面
          if (this.$route.path !== targetPath) {
            router.push({ path: targetPath });
          }
        } else {
          this.$toast("菜单暂无配置");
        }
      }
    },
    // 处理商品点击事件
    handleGoodsClick(goods) {
      console.log("点击商品", goods);
      // 跳转到商品详情页，使用商品编号作为参数
      if (goods.goodsCode) {
        this.$router.push({
          path: `/placeAnOrder/templateOne/${goods.goodsCode}`,
        });
      }
    },
    // 切换tab
    changeTab(e) {
      console.log("切换tab", e);
      this.pageParams.current = 1; // 重置页码
      this.goodsList = []; // 清空列表
      this.finished = false; // 重置加载完成状态
      this.getGoodsList();
    },
    // 下拉刷新
    onRefresh() {
      console.log("下拉刷新");
      this.pageParams.current = 1; // 重置到第一页
      this.finished = false; // 重置加载完成状态
      this.getGoodsList(true); // true 表示是刷新操作
    },
    // 上拉加载更多
    onLoadMore() {
      console.log("上拉加载更多");
      // 如果已经加载完成，不再请求
      if (this.finished) {
        this.loadingMore = false;
        return;
      }
      // 如果当前页码已经是最后一页，标记为已完成
      if (this.pageParams.current >= this.pageParams.pages) {
        this.finished = true;
        this.loadingMore = false;
        return;
      }
      // 加载下一页
      this.pageParams.current += 1;
      this.getGoodsList(false, true); // 第二个参数 true 表示是加载更多操作
    },
    // 获取配置信息
    getConfig() {
      getCustomMallConfig(this.code).then((res) => {
        console.log("商城配置信息的res", res);
        this.templateNo = res.data.templateNo;
        this.componentList = JSON.parse(res.data.mallConfig).components;
        console.log("this.componentList", this.componentList);
      });
    },
    // 获取商品列表
    getGoodsList(isRefresh = false, isLoadMore = false) {
      if (this.loading) return;
      this.loading = true;
      const params = {
        model: {
          mallCode: this.code || "mAXVHw5248",
          belongCity: "", // 归属市，根据实际需求传入
        },
        size: this.pageParams.size,
        current: this.pageParams.current,
      };

      // 如果不是全部tab，添加上游渠道类型筛选
      if (this.currentUpstreamChannelType !== null) {
        params.model.upstreamChannelType = this.currentUpstreamChannelType;
      }

      getGoodsList(params)
        .then((res) => {
          console.log("商品列表的res", res);
          if (res.code === 0 && res.data) {
            // 映射接口返回的字段到页面展示的字段
            const newList = res.data.records.map((item) => ({
              id: item.goodsCode, // 商品编号作为唯一id
              title: item.goodsName, // 商品名称
              info: item.goodsIntroduction, // 商品简介
              showSalesVolume: item.showSalesVolume || "0", // 销量
              price: item.price, // 销售价
              tagList: item.goodsTag
                ? item.goodsTag.split(",").filter((tag) => tag.trim())
                : [], // 商品标签，假设用逗号分隔
              img: item.goodsThumbnailUrl, // 商品缩略图
              goodsCode: item.goodsCode, // 商品编号，用于跳转
              upstreamChannelType: item.upstreamChannelType, // 上游渠道类型
            }));

            // 根据操作类型处理数据
            if (isRefresh) {
              // 下拉刷新：替换列表数据
              this.goodsList = newList;
            } else if (isLoadMore) {
              // 上拉加载：追加到列表末尾
              this.goodsList = [...this.goodsList, ...newList];
            } else {
              // 初始加载或切换tab：直接替换
              this.goodsList = newList;
            }

            // 更新分页信息
            this.pageParams.current = res.data.current;
            this.pageParams.total = res.data.total;
            this.pageParams.pages = res.data.pages;

            // 判断是否已经加载完所有数据
            if (this.pageParams.current >= this.pageParams.pages) {
              this.finished = true;
            } else {
              this.finished = false;
            }

            // 如果当前页没有数据，也标记为完成
            if (!newList || newList.length === 0) {
              this.finished = true;
            }
          } else {
            this.$toast(res.msg || "获取商品列表失败");
            // 如果是加载更多失败，页码回退
            if (isLoadMore) {
              this.pageParams.current -= 1;
            }
            // 如果是初始加载失败，清空列表
            if (!isLoadMore && !isRefresh) {
              this.goodsList = [];
            }
          }
        })
        .catch((err) => {
          console.error("获取商品列表失败", err);
          this.$toast("获取商品列表失败");
          // 如果是加载更多失败，页码回退
          if (isLoadMore) {
            this.pageParams.current -= 1;
          }
          // 如果是初始加载失败，清空列表
          if (!isLoadMore && !isRefresh) {
            this.goodsList = [];
          }
        })
        .finally(() => {
          this.loading = false;
          // 结束下拉刷新状态
          if (isRefresh) {
            this.refreshing = false;
          }
          // 结束上拉加载状态
          if (isLoadMore) {
            this.loadingMore = false;
          }
        });
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  .component {
    background-color: #f5f5f5;
    overflow: hidden;
    transition: all 0.2s;

    .text {
      padding: 10px 0;
    }

    .content {
      width: 100%;
      background-color: #f5f5f5;
      .content_nav {
        width: 100%;
        /deep/.van-tab--active {
          color: #f92f35;
          font-weight: 500;
          font-size: 16px;
        }
        /deep/.van-tabs__nav--line {
          padding-bottom: 12px;
          background-color: #f5f5f5;
        }
        /deep/.van-tabs__line {
          width: 18px;
        }
        .van-tab__pane {
          padding: 10px;
        }
        .goods_list {
          width: 100%;
          margin: 10px 0;
          padding: 10px;
          border-radius: 6px;
          box-sizing: border-box;
          background-color: #fff;
          .goods_list_top {
            display: flex;
            img {
              width: 110px;
              height: 110px;
              vertical-align: bottom;
            }
            .goods_list_top_r {
              width: 250px;
              margin-left: 10px;
              text-align: left;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              .list_title {
                font-size: 16px;
                font-weight: bold;
                margin: 2px 0;
                text-align: justify;
                overflow: hidden; //超出隐藏
                text-overflow: ellipsis; //超出使用省略号
                display: -webkit-box;
                -webkit-line-clamp: 1; //第几行
                -webkit-box-orient: vertical;
              }
              .list_info {
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                margin: 2px 0;
                text-align: justify;
                overflow: hidden; //超出隐藏
                text-overflow: ellipsis; //超出使用省略号
                display: -webkit-box;
                -webkit-line-clamp: 2; //第几行
                -webkit-box-orient: vertical;
              }
              .list_sales {
                font-size: 12px;
                color: #999999;
                margin: 2px 0;
              }
              .list_price {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .price {
                  font-size: 12px;
                  color: #f92f35;
                  .price_num {
                    font-size: 22px;
                    font-weight: bold;
                  }
                }
                .btn {
                  width: 100px;
                  height: 30px;
                  color: #fff;
                  border: none;
                  border-radius: 6px;
                  background-color: #f92f35;
                }
              }
            }
          }

          .list_tagList {
            margin: 6px 0;
            display: flex;
            flex-wrap: wrap;
            .tag {
              font-size: 14px;
              padding: 2px 6px;
              border-radius: 6px;
              margin: 4px 0;
              margin-right: 10px;
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
        .goods_card {
          text-align: left;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
          .goods_card_item {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-radius: 6px;
            background-color: #fff;
            .goods_card_item_img {
              width: 100%;
              aspect-ratio: 1 / 1; // 1:1 宽高比
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover; // 保持图片比例,裁剪超出部分
                vertical-align: bottom;
              }
            }
            .card_title {
              font-size: 16px;
              font-weight: bold;
              margin: 4px 0;
              text-align: justify;
              overflow: hidden; //超出隐藏
              text-overflow: ellipsis; //超出使用省略号
              display: -webkit-box;
              -webkit-line-clamp: 2; //第几行
              -webkit-box-orient: vertical;
            }
            .card_info {
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              margin: 4px 0;
              text-align: justify;
              overflow: hidden; //超出隐藏
              text-overflow: ellipsis; //超出使用省略号
              display: -webkit-box;
              -webkit-line-clamp: 2; //第几行
              -webkit-box-orient: vertical;
            }
            .card_tag {
              margin: 6px 0;
              display: flex;
              flex-wrap: wrap;
              .card_tag_item {
                font-size: 14px;
                padding: 2px 6px;
                border-radius: 4px;
                margin: 4px 0;
                margin-right: 10px;
                &:last-child {
                  margin-left: 0;
                }
              }
            }
            .card_price {
              font-size: 12px;
              color: #f92f35;
              .price_num {
                font-size: 22px;
                font-weight: bold;
              }
            }
            .card_sales {
              font-size: 12px;
              color: #999999;
              margin: 4px 0;
            }
          }
        }
      }
    }

    .topnav {
      padding: 10px;
      margin: 10px;
      border-radius: 6px;
      background-color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .topnav_item {
        text-align: center;

        img {
          width: 30px;
          height: 30px;
          margin-bottom: 5px;
          vertical-align: bottom;
        }
      }
    }

    .carousel {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 160px;
        vertical-align: bottom;
      }
    }
  }

  .fixed_bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    border-top: 1px solid #e8e8e8;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;

      .bottom_item {
        flex: 1;
        font-size: 14px;
        text-align: center;

        img {
          width: 22px;
          height: 22px;
          margin-bottom: 5px;
          vertical-align: bottom;
        }
      }
    }
  }
}
</style>
